export default __webpack_public_path__ + "static/media/DoubleToroOpen.0e1e7749.jpg";